module.exports = __webpack_public_path__ + "static/media/checked-furniture.67f3b028.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/checked-furniture.png
// module id = 1217
// module chunks = 27